<template>
	<div
    v-if="item"
		class="extra-box shadow-box"
		:class="{ 'green': $_extraAction_quantityExtraInOrder(item.id) > 0 }"
    :style="$_extraAction_outOfStock(item) && $_extraAction_quantityExtraInOrder(item.id) <= 0 ? 'opacity: 0.5' : ''"

	>
		<div
			class="extra-img"
			@click="openModalExtra(item)"
		>
			<progressive-image
				:src="item.images.small
					? item.images.small
					: item.images.big"
			/>

			<div class="extra-shadow"></div>
      
        <div
          class="container-recipe-tags"
					:class="{'align-items-baseline': fixedDiscount}"
					v-if="$route.name !== 'order-now-voiello'"
        >
          <tags-line-orange
            :items="tagsMarketing"
          />
					<span class="promo-button" v-if="item.price && item.discount.value > 0 || fixedDiscount">Promo</span>
        </div>

		</div>

		<div class="extra-info-block">
				
			<div :class="{'flex': $mq.isDesktop()}">
				<div class="extra-title trunced" v-html="item.title" @click="toProduct(item)"/>

				<div class="extra-price flex-right" :style="item.price && item.discount.value > 0 ? 'height: 60px' : ''">
					<nobr :class="{'text-muted text-decoration-line-through link-big-detail' : fixedDiscount}">{{ item.price | priceFilter }}</nobr>
					<div class="price d-flex align-items-center" v-if="item.price && item.discount.value > 0">
						<small class="text-danger text-bold"> - {{item.discount.value * 100}} %</small>
						<small class="px-3 text-muted">|</small>
						<small class="text-muted text-decoration-line-through">€ {{item.discount.original}}</small>
          </div>
					<div class="price d-flex align-items-center" v-else-if="fixedDiscount">
						<small class="text-danger text-bold" style="font-size: 20px">{{(item.price - fixedDiscount).toFixed(2) | priceFilter }}</small>
          </div>
					<div v-else style="font-size: 7px"><br><br></div>
				</div>
			</div>

			<slot name="description" />

			<div class="flex-bottom">

				<div class="extra-prod flex-bottom flex">
					<div v-if="item.product.supplier.name">
						<img src="../../assets/img/supplier-icon.png" class="supplier-icon"> {{ item.product.supplier.name }}
					</div>
				</div>
				<div class="extra-prod flex-bottom flex">
					<div v-if="item.product.weight" class="flex-right info-small">
						ca. {{ item.product.weight / 1000 }} kg
					</div>
					<div v-else class="flex-right info-small">
						&nbsp;
					</div>
				</div>
        <section-toggle
					v-if="noIngredients"
          :trigger.sync="showInfo"
        >
          <template slot="title">
						<b v-if="fixedDiscount">Prodotti</b>
            <b v-else>Ingredienti</b>
          </template>

          <template slot="content">
            <div class="flex flex-wrap section-ingredients">
							<div class="order-now-ingredients" v-if="$route.name === 'order-now'">
								<v-list-item 
									v-for="(ingredient, index) in item.ingredients" 
									:key="index"
									class="ingredient-item"
									style="width: 100%"
								>
									<v-list-item-content class="ingredient-image" style="padding: 3px 0 !important">
										<img :src="ingredient.images.small">
									</v-list-item-content>
									<v-list-item-content class="flex item-content">
									<span v-html="ingredient.name" class="text-left" style="font-size: 12px"/>
									<span class="text-left" style="font-size: 12px"> ({{ingredient.quantity}} pz.)</span>
									</v-list-item-content>
								</v-list-item>
							</div>
             <SliderQ
						 		v-else
                :maxNumSlides="6"
                :minSizeOfSlide="70"
              >
                <slide
                  v-for="(ingredient, index) in item.ingredients"
									:key="index"
                  class="ingredient"
                >
                  <div class="ingredient-badge flex-center">
                    <img :src="ingredient.images.small">
                  </div>
                  <div
                  class="mt-1 text-center ingredient-name"
                    v-html="ingredient.name"
                  />
                </slide>
              </SliderQ>

              <!--<div v-if="raw.allergens.length > 0">
                <b>Allergeni:</b><br> {{ allergens }}
              </div>-->
            </div>
          </template>
        </section-toggle>

				<div
					v-if="!$_extraAction_extraAvailable(item)"
					class="extra-action"		
				>
					<div
						class="disabled"
						v-html="`ANDATO A RUBA :)`"
					/>
				</div>

				<div
					v-if="$_extraAction_extraAvailable(item) && action === false"
					class="extra-action"		
				>
					<div
						class="enabled"
						v-html="`DISPONIBILE`"
					/>
				</div>

				<div
					v-if="$_extraAction_extraAvailable(item) && action !== false"
					class="extra-action"
				>
					<template v-if="$_extraAction_quantityExtraInOrder(item.id) > 0">
						<div
							class="flex flex-vcenter"
						>
							<CTA
								class="full"
								:disabled="updating"
								@click="$_extraAction_remove(item)"
								:content="`-`"
							/>

							<div class="quantity-extra">
								{{ $_extraAction_quantityExtraInOrder(item.id) }}
							</div>

							<CTA
								class="full"
								:disabled="updating || $_extraAction_outOfStock(item) || maxAvailable == item.quantity+1"
								@click="$_extraAction_add(item); triggerSnackbar()"
								:content="`+`"
							/>
						</div>
					</template>

					<template v-else>
						<CTA
							class="full not-in-box"
							:disabled="updating"
							@click="$_extraAction_add(item); $route.name !== 'order-now' ? triggerSnackbar() : scrollToCta()"
							:content="$mq.isDesktop() ? $t('components.checkout.cart.edit.desktop') : $t('components.checkout.cart.edit.mobile_alt')"
						/>
					</template>

				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import { extraAction } from '../../mixins/extraAction'
import TagsLineOrange from '../Parts/TagsLineOrange'
import SectionToggle from '../Parts/SectionToggle'

export default {
  components: {
    SectionToggle,
    TagsLineOrange
  },
  data() {
    return {
      showInfo: false
    }
  },
  computed: {
    tagsMarketing () {
      if (!this.item) return
      return this.item.marketingTags
    },
  },
	props: {
		item: {
			type: Object,
			default () {
				return null
			}
		},
		order: {

		},
    productables: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: Boolean,
      default: true
    },
		action: {
			type: Boolean,
			default: true
		},
		noIngredients: {
			type: Boolean,
			default: false
		},
		fixedDiscount: {
			type: Number,
			default: 0
		}
	},

	mixins: [
		extraAction
	],

	methods: {

    loadInfo() {

      if (!this.item || this.ingredients) {
        return;
      }

      let api = new ExtraApi;

      this.loading = true;

      api.recipe(this.item.id).then(i => {
        this.raw = i.body.data.resource
        this.loading = false;
      })
    },
		openModalExtra (item) {

			this.redirect && this.$router.push({name: 'product', params: {id: item.id, slug: 'preview'} } )

			//this.$emit('openModalExtra', item)
		},
		toProduct(item) {
			this.redirect && this.$router.push({name: 'product', params: {id: item.id}})
		},

		triggerSnackbar() {
			if(!this.user.email.includes('guest.quomi.it')){
				window.dispatchEvent(new CustomEvent('trigger-snackbar', { 
        	bubbles: true
      	}));
			}
			if(this.$route.name === 'order-now') {
				this.$emit('scroll-cta')
			}
		},

		scrollToCta() {
				this.$emit('scroll-cta')
		}
	}
}

</script>

<style scoped>
	.extra-box {
		text-align: center;
		display: flex;
		flex-flow: column;
		height: 100%;
	}

	.extra-prod {
		color: #8c8c8c;
		font-size: 13px;
		align-items: center;
	}

	.disabled {
		padding: 5px 20px;
		margin-top: 10px;
		color: var(--quomi-orange);
	}

	.enabled {
		padding: 5px 20px;
		margin-top: 10px;
		color: var(--quomi-primary);
	}

	.extra-info-block {
		padding: 20px 15px;
		text-align: right;
		display: flex;
    flex-direction: column;
    flex-basis: 100%;
	}
  .container-recipe-tags {
    position: absolute;
    margin-left: -5px;
    margin-top: -35px;
    min-height: 35px;
		display: flex;
		align-items: center;
		flex-flow: row ;
    padding: 5px 15px;
    z-index: 1;
    bottom: 0;
    margin-bottom: -15px;
  }

	.extra-box.border-green {
		border: 1.5px solid var(--quomi-primary);;
	}

	.extra-price {
		font-size: 22px;
		font-weight: bold;
	}

	.price {
		font-size: 15px;
		white-space: nowrap;
	}

	.extra-title {
		text-align: left;
		font-size: 16px;
		margin-right: 10px;
		margin-bottom: 10px;
		overflow: hidden;
	}

	.extra-title:hover {
		cursor: pointer;
	}

	.extra-title.trunced {
		display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 50px;
    margin-bottom: 10px;
    word-break: break-word;
	}

	.btn.full {
		width: 100%;
	} 

	.btn {
		margin-bottom: 0px;
	}

	.extra-img {
		cursor: pointer;
		position: relative;
	}

	.extra-shadow {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.12) 0, rgba(0,0,0,0) 60%, transparent);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
	}

	.extra-action {
		display: flex;
		flex-wrap: nowrap;
		font-weight: bold;
		align-items: center;
		justify-content: center;
		min-height: 47px;
	}

	.extra-action .flex-right {
		display: flex;
	}

	.extra-action button {
		padding: 5px 20px;
		background-color: var(--quomi-primary);
		color: white;
		border: 1.5px solid var(--quomi-primary);
	}

	.extra-action .btn:not(.full) {
		font-size: 18px;
		padding: 3px 15px;
	}

	.extra-action button.full {
		background-color: var(--quomi-primary);
		color: white;
	}

	.extra-action .quantity-extra {
		padding: 5px 20px;
		z-index: 1;
	}

	.supplier-icon {
		width: 15px;
		padding-bottom: 3px;
	}

	.flex-bottom {
		margin-top: auto;
	}

	.not-in-box {
		background: white !important;
		color: var(--quomi-primary) !important;
	}

	.promo-button{
		padding: 0 8px;
		border: 2px solid white;
    border-radius: 5px;
		text-transform: uppercase;
    font-size: 13px;
		font-weight: bold;
    background: red;
    color: white;
	}

	.order-now-ingredients {
		max-height: 200px; 
		overflow-y: scroll;
	}

	
	.ingredient-image {
		margin-right: 12px;
	}

	.ingredient div:nth-child(2) {
		line-height: normal;
	}

	.item-content {
		max-width: 60%;
	}

	@media(max-width: 640px) {
		.container-recipe-tags {
			bottom: -12px;
			padding: 5px 10px;
		}

		.extra-action button.full {
		background-color: var(--quomi-primary) !important;
		color: white !important;
		width: 80%;
		}

		.extra-price {
		position: absolute;
		bottom: 25%;
		font-size: 18px;
		}

		.extra-title.trunced {
			font-weight: var(--font-bold);
	}
		
		.promo-button{
			font-size: 7px;
		}

		.order-now-ingredients {
			max-width: 100%;
			max-height: 150px; 
		}

		.ingredient-image {
			max-width: 70%;
			margin-right: 0;
		}

		.ingredient-name {
			font-size: 13px;
		}

		.ingredient-item {
			display: contents;
		}
		
		.item-content {
			max-width: 100%;
			word-break: break-word;
		}

		.price {
			margin-bottom: 10px;
			font-size: 12px;
		}
	}
	
	@media(max-width: 768px) {
		.extra-title {
			font-size: 13px;
		}

		.extra-title.trunced {
			height: 55px;
		}

		.extra-action .quantity-extra {
			padding: 5px 10px;
		}

		.extra-info-block {
			padding: 20px 10px;
		}

		.extra-prod,
		.disabled {
				font-size: 9px;
		} 

		.order-now-ingredients::-webkit-scrollbar {
				display: none;
		}
	}

		@media(max-width: 1024px) {
			.extra-info-block {
				text-align: left;
			}
		}

		@media(min-width: 1024px) {
			.ingredient-image {
					max-width: 25%;
			}
		}

		@media(max-width: 320px) {
			.promo-button {
				padding: 1px 4px;
			}
			.extra-prod {
				font-size: 8px;
			}
		}
</style>
